var map = {
	"./cover1.png": 849,
	"./cover10.png": 61,
	"./cover2.png": 882,
	"./cover3.png": 707,
	"./cover4.png": 844,
	"./cover5.png": 741,
	"./cover6.png": 766,
	"./cover7.png": 703,
	"./cover8.png": 856,
	"./cover9.png": 73,
	"./logo.png": 806,
	"./profile.png": 572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 811;